import { useSuspenseQuery } from '@tanstack/react-query';
import apiClient from '@/lib/apiClient';
import { getCurrentAuthUser } from '@/utils/token';

interface AwardFileStatus {
  isComplete: boolean;
  isError: boolean;
}

interface AwardFileStatusParams {
  startDate: string;
  endDate: string;
  makerIds: string[];
}

async function fetchAwardFileStatus({
  startDate,
  endDate,
  makerIds,
}: AwardFileStatusParams): Promise<{ isComplete: boolean; isError: boolean }> {
  const currentAuthUser = getCurrentAuthUser();
  const searchParams = new URLSearchParams();
  searchParams.set('startDate', startDate);
  searchParams.set('endDate', endDate);
  makerIds.forEach((id) => searchParams.append('makerIds', id));

  const statusEndpoint = `usercast/api/c2fo/taker/consolidated-history/award/${
    currentAuthUser?.uuid ?? ''
  }/archive-by-deposit-date/status`;

  const response = await apiClient.get(statusEndpoint, { searchParams }).json<{
    data: AwardFileStatus[];
  }>();

  const files = response.data ?? [];

  return {
    isComplete: files.length > 0 && files.every((r) => r.isComplete),
    isError: files.length === 0 || files.some((r) => r.isError),
  };
}

const useAwardFileStatus = (params: AwardFileStatusParams) => {
  return useSuspenseQuery({
    queryKey: ['award-file-status', params],
    queryFn: () => fetchAwardFileStatus(params),
  });
};

export default useAwardFileStatus;
